// JavaScript Document
var loadingBoxState = false;
var loadingBoxInst = 0;
var messageInBar = 0;
var loadingBoxDefaultMessage;
var loadingBoxMsgLock = false;
var activeMessages = new Set();

/**
 * affiche et masque la boite de chargement
 * @param boolean state
 */
global.loadingBox = function(state) {
    if (!loadingBoxDefaultMessage) {loadingBoxDefaultMessage  = $( "#mainToolbarStatus" ).html();}

	if (loadingBoxInst < 1 && !loadingBoxMsgLock) {
		setStatusBarMessage(loadingBoxDefaultMessage, 'loading', 0);
	}

	if (state) {
		loadingBoxInst += 1;
	}
	else {
		loadingBoxInst -= 1;
	}

	// protégé la variable à 0
	if (loadingBoxInst<0){
		loadingBoxInst = 0;
	}
	displayToolbar();
}

global.msg = function(state, message, time) {
	if (!loadingBoxDefaultMessage) {loadingBoxDefaultMessage  = $( "#mainToolbarStatus" ).html();}

	if (!time) {time = 5000}
	messageInBar += 1;
	setStatusBarMessage(message, state, time);
	displayToolbar();

	// timeout
	setTimeout(function(){
		messageInBar -= 1;
		displayToolbar();
	},time);

	// protégé la variable à 0
	if (messageInBar<0){
		messageInBar = 0;
	}
}

global.displayToolbar = function() {
	if ((loadingBoxInst > 0 || messageInBar > 0) && !loadingBoxState) {
		loadingBoxState = true;
	}
	else if ((loadingBoxInst <= 0 && messageInBar <= 0) && loadingBoxState) {
        // toastr.clear();
		loadingBoxState = false;
	}
}

global.setStatusBarMessage = function (message, state, time) {
	const uniqueKey = `${state}:${message}`;

	// Vérifier si le message existe déjà
	if (activeMessages.has(uniqueKey)) {
		return;
	}

	toastr.options = {
		"closeButton": false,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-bottom-right",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": time,
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut",
		"tapToDismiss": true,
		"onHidden": function () {
			// Retirer le message actif lorsqu'il est fermé
			activeMessages.delete(uniqueKey);
		}
	};

	// Ajouter le message à la liste des actifs et afficher
	activeMessages.add(uniqueKey);
	toastr.clear();
	toastr.msg(state, message);
};
